import { Component, HostBinding } from '@angular/core';
import { NavigationCoreComponent } from '../navigation-core.component';
import '@diekeure/dcr-components/dcr-plain-tooltip.js';

@Component({
  standalone: false,
  selector: 'campus-navigation-rail, [navigation-rail]',
  templateUrl: './navigation-rail.component.html',
  styleUrls: ['./navigation-rail.component.scss'],
})
export class NavigationRailComponent extends NavigationCoreComponent {
  @HostBinding('class')
  defaultClasses = [
    'navigation-rail',
    'stack',
    'stack-space-s',
    'p-b-m',
    'items-center',
    'overflow-x-hidden',
    'overflow-y-auto',
  ];
}
